/**
 * Menü aus Login-API: Seiten ohne führendes "/" sind relativ zur aktuellen URL (z. B. /dashboard/…) und brechen.
 */
export function normalizeMenuRouterPaths(menu: any): void {
  if (!menu) {
    return;
  }
  const fixItem = (it: any) => {
    if (!it || it.page === undefined || it.page === null || it.page === 'null') {
      return;
    }
    const p = String(it.page).trim();
    if (!p || p.startsWith('/') || p.startsWith('http') || p.startsWith('mailto:')) {
      return;
    }
    it.page = '/' + p;
  };
  const walk = (items: any[]) => {
    if (!items || !Array.isArray(items)) {
      return;
    }
    for (const it of items) {
      fixItem(it);
      if (it.submenu?.items) {
        walk(it.submenu.items);
      }
    }
  };
  walk(menu.horizontal_menu?.items);
  walk(menu.vertical_menu?.items);
}
